import { combineReducers } from "redux";
import students from "../features/admin/role_permmission/student/Slice";
import colleges from "../features/admin/role_permmission/college/Slice";
import hotels from "../features/admin/role_permmission/hotel/Slice";
import roles from "../features/admin/role_permmission/role/Slice";

const customers = combineReducers({
  roles: roles,
  students: students,
  colleges: colleges,
  hotels: hotels,
});

export default customers;
